import React, { useEffect, useState, useCallback } from 'react'
import { UsersDataGrid } from './UsersDataGrid'
import { useSelector, useDispatch } from 'react-redux'
import * as components from '../../components'
import * as rest from '../../services'
import { showErrorToast } from '../../state/toasts'
export const UserListPage = (props) => {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth)
  const [gridData, setGridData] = useState({})
  const [getAPIResults, setGetAPIResult] = useState(null)
  const [hiddenRowKeys, setHiddenRowKeys] = useState([])
  const handleTableChange = (type, { page, sizePerPage }) => {
    const paginationFilters = {
      page: page,
      page_size: sizePerPage,
    }
    setGridData(paginationFilters)
  }
  const onFilter = (data) => {
    const searchFilters = data ? { ...data, page: 1 } : gridData
    setGridData({ ...searchFilters })
  }
  const getData = useCallback(
    (data) => {
      let finalPayload = { ...gridData, ...data }
      setGetAPIResult(null)
      new rest.UserService()
        .makeGetRequest(finalPayload)
        .then((response) => {
          setGetAPIResult(response)
        })
        .catch((errors) => {
          dispatch(showErrorToast('Error', 'Could not get user list data'))
        })
    },
    [gridData, dispatch]
  )
  useEffect(() => {
    getData()
  }, [user, getData])
  return !getAPIResults ? (
    <components.Loading />
  ) : (
    <>
      <UsersDataGrid
        handleTableChange={handleTableChange}
        onFilter={onFilter}
        getData={getData}
        hiddenRowKeys={hiddenRowKeys}
        results={getAPIResults.results}
        pageSize={getAPIResults.page_size}
        count={getAPIResults.count}
        current={getAPIResults.current}
        onDelete={(item) => {
          setHiddenRowKeys([...hiddenRowKeys, item.url])
        }}
      ></UsersDataGrid>
    </>
  )
}
